import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { brand } from "../theme";
import Logo from "./Logo";

const highlights = [
  "Publicá tu auto en minutos",
  "Hablá directo con compradores y vendedores",
  "Sin intermediarios",
];

// Pantalla de acceso: panel de marca a la izquierda (escritorio) y formulario a la derecha
const AuthLayout = ({ title, subtitle, children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "grid",
      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
      bgcolor: "background.default",
    }}
  >
    <Box
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        justifyContent: "space-between",
        p: 6,
        color: brand.cream,
        background: `radial-gradient(circle at 20% 110%, ${brand.coral}33 0%, transparent 45%), linear-gradient(160deg, ${brand.ink} 0%, ${brand.inkDark} 100%)`,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Logo size={44} sx={{ "& rect": { fill: brand.inkLight } }} />
        <Typography sx={{ fontWeight: 800, fontSize: 24, letterSpacing: "-0.02em" }}>Caro</Typography>
      </Stack>
      <Box sx={{ maxWidth: 440 }}>
        <Typography sx={{ fontWeight: 800, fontSize: 40, lineHeight: 1.1, letterSpacing: "-0.03em" }}>
          Comprá y vendé autos,{" "}
          <Box component="span" sx={{ color: brand.coral }}>
            sin vueltas.
          </Box>
        </Typography>
        <Stack spacing={1.5} sx={{ mt: 4 }}>
          {highlights.map((text) => (
            <Stack key={text} direction="row" spacing={1.5} alignItems="center">
              <CheckCircleIcon sx={{ color: brand.coral, fontSize: 20 }} />
              <Typography sx={{ opacity: 0.85 }}>{text}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
      <Typography variant="caption" sx={{ opacity: 0.5 }}>
        © {new Date().getFullYear()} Caro
      </Typography>
    </Box>

    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: { xs: 2, sm: 4 } }}>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 440,
          p: { xs: 3, sm: 4 },
          borderRadius: 4,
          border: 1,
          borderColor: "divider",
        }}
      >
        <Logo size={56} sx={{ mb: 2, display: { md: "none" } }} />
        <Typography component="h1" variant="h5">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 1 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </Paper>
    </Box>
  </Box>
);

export default AuthLayout;
